import React, { useState, useEffect  } from 'react';
// import PageLoader from "../../components/custom/PageLoader";
import DOMPurify from "dompurify";

import { FormInstance } from "antd";

interface GeofenceMobilePreviewPageProps {
  form: FormInstance;
  description: string;
  imageData: { file: File; base64Data: string }[];
  isNavigationVisible?: boolean;
  mode: string;
  fileUrl : string[];
}

export const GeofenceMobilePreviewPage: React.FC<GeofenceMobilePreviewPageProps> = ({ 
    form,
    description,
    imageData,
    isNavigationVisible,
    mode,
    fileUrl,
   }) => {
     //const cleanDescription = description.replace(/<img[^>]*>/g, "");
     const cleanDescription = (() => {
      if (!description) return "";
       const cleaned = description
         .replace(/<img[^>]*>/gi, "")
         .replace(/<p>(\s|&nbsp;)*<\/p>/gi, "")
         .replace(/&nbsp;/gi, " ")
         .trim();

       return DOMPurify.sanitize(cleaned);
     })();

     const subject = form.getFieldValue("Subject");
     const emailText = form.getFieldValue("EmailText");
  return (
    <div style={styles.frame}>
      {/* Notch */}
      <div style={styles.notch}>
        <div style={styles.speaker}></div>
        <div style={styles.camera}></div>
      </div>

      {/* {isPageLoading && <PageLoader />} */}

      {/* Scrollable container – includes top + white area */}
      <div style={styles.scrollableArea} className="mobile-scroll">
        {/* Top colored area */}
        <div style={styles.topArea}>
          <div style={styles.topRow}>
            <span style={styles.hamburger}>☰</span>
          </div>
          <div style={styles.logoWrapper}>
            <img src="/images/MobileORLogo.png" alt="App Logo" style={styles.appLogo} />
          </div>
        </div>

        {/* White content area */}
        <div style={styles.screen}>
          <span style={styles.closeIcon}>✕</span>

         {/* Mobile Inner Content */}
          <div style={styles.previewContainer}>
              {/* Campaign Name */}
              <div style={styles.campaignName}>
                {form.getFieldValue("CampaignName") || "Campaign Name"}
              </div>

              {/* Divider line */}
              <div style={styles.divider}></div>

              {/* Email Subject Line */}     
              {subject?.trim() && (
              <div style={styles.subjectText}>
                {subject.trim()}
              </div>
              )}
                            
              {/* Email Text */}
              {emailText?.trim() && (
              <div style={styles.emailText}>
                {emailText.trim()}
              </div>
               )}

              {/* Description */}
            <div
              data-inline-description
              style={styles.description}
              dangerouslySetInnerHTML={{ __html: cleanDescription  }}
             >
            </div>

            <style>
              {`
                [data-inline-description] p,
                [data-inline-description] figure {
                  margin: 4px 0 !important; /* tighten spacing */
                  padding: 0 !important;
                }
              `}
            </style>

              {/* Image */}
              {mode === "create" && (
                    <>
              {imageData && imageData.length > 0 && (
                <div style={styles.imageRow}>
                    {imageData.map((img, index) => (
                      <img
                        key={index}
                        src={img.base64Data}
                        alt={`Uploaded ${index + 1}`}
                        style={styles.previewImage}
                      />
                    ))}
                  </div>
              )}
              </>
              )}

              {(mode === "update" || mode === "view") && (
                <>
                  {fileUrl && fileUrl.length > 0 && (
                    <div style={styles.imageRow}>
                      {fileUrl.map((url, index) => (
                        <img
                          key={index}
                          src={url}
                          alt={`File Image ${index + 1}`}
                          style={styles.previewImage}
                        />
                      ))}
                    </div>
                  )}
              </>
              )}

              {/* Navigation Button */}
              {
                isNavigationVisible &&
                (
                <button style={styles.greenButton} >Get Navigation</button>  
                )
              }
            </div>
          
        </div>
      </div>

      {/* Hide scrollbar (WebKit) */}
      <style>
        {`
          .mobile-scroll::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
    </div>
  );
};

export default GeofenceMobilePreviewPage;

const styles: { [key: string]: React.CSSProperties } = {
  frame: {
    width: "320px",
    height: "667px",
    border: "14px solid #222",
    borderRadius: "40px",
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  scrollableArea: {
    flex: 1,
    overflowY: "auto",
    scrollbarWidth: "none", 
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
  },
  notch: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "200px",
    height: "15px",
    backgroundColor: "#222",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "4px 8px",
    zIndex: 3,
    boxSizing: "border-box",
  },
  speaker: {
    width: "40px",
    height: "4px",
    backgroundColor:"white",
    borderRadius: "2px",
  },
  camera: {
    width: "8px",
    height: "10px",
    backgroundColor:"white",
    borderRadius: "50%",
    boxShadow: "0 0 1px #000",
     alignSelf: "flex-end",
  },
  topArea: {
    backgroundColor: "#63555B",
    paddingTop: "36px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },

  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "20px",
  },

  hamburger: {
    fontSize: "0.95rem",
    color: "white",
  },

  logoWrapper: {
    marginBottom: "18px",
    width: "40%",
    marginLeft: "auto",
    marginRight: "auto",
  },

  appLogo: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    display: "block",
  },

  screen: {
    padding: "1rem 1.5rem 1rem 1rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    marginTop: "-20px",
    boxSizing: "border-box",
    position: "relative",
    zIndex: 2,
  },

  closeIcon: {
    position: "absolute",
    top: "12px",
    right: "16px",
    fontSize: "1rem",
    color: "#999",
  },
  sectionBlock: {
    marginBottom: "20px",
  },
  groupTitle: {
    fontSize: "10px",
    fontWeight: "normal",
    margin: "10px 0",
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  },
  fullWidthImage: {
    width: "100%",  
    height: "102px", 
    objectFit: "cover",
    borderRadius: "12px",
  },
  twoImageRow: {
    display: "flex",
    gap: "8px",
  },
  halfImage: {
    flex: 1,
    maxWidth: "48%",
    height: "102px",
    objectFit: "cover",
    borderRadius: "12px",
  },
  scrollableRow: {
    display: "flex",
    overflowX: "auto",
    alignItems: "center",
    gap: "8px",
  },
  smallImage: {
    width: "120px",
    height: "102px",
    objectFit: "cover",
    borderRadius: "12px",
    flexShrink: 0,
  },
  moreIcon: {
    fontSize: "24px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  previewContainer: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: "16px",
  fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
},

campaignName: {
  fontSize: "16px",
  fontWeight: 600,
  color: "#333",
  marginBottom: "4px",
  alignSelf: "flex-start", 
  textAlign: "left",
  width: "100%",      
},
divider: {
  width: "100%",
  height: "2px",
  backgroundColor: "#C19763",
  margin: "10px 0 16px 0",
  borderRadius: "2px",
  
},
previewImage: {
  width: "100%",
  borderRadius: "12px",
  objectFit: "cover",
  marginBottom: "12px",

  border: "1px solid #ccc",
},
imageRow: {
    display: "flex",
    flexWrap: "wrap", // allow wrapping on smaller screens
    gap: 12,           // spacing between images
    marginTop: 16,
  },
description: {
  fontSize: "13px",
  color: "#999",
  lineHeight: "1.4",
  marginBottom: "8px",
  alignSelf: "flex-start", 
  textAlign: "left",
  width: "100%", 
},
emailText: {
  fontSize: "13px",
  color: "#555",
  marginBottom: "14px",
  alignSelf: "flex-start",
  textAlign: "left",
  width: "100%",     
},
subjectText: {
  fontSize: "14px",
  color: "#333",
  fontWeight: "600",
  marginBottom: "14px",
  alignSelf: "flex-start",
  textAlign: "left",
  width: "100%",
},
greenButton: {
  padding: "8px 24px",
  fontSize: '13px',
  borderRadius: '20px',
  fontWeight: 500,
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  border: `2px solid #3E767A`,
  color: '#F1F2F4',
  backgroundColor: '#3E767A',
  cursor: "default",
  pointerEvents: "none",
  transition: "none !important",
},

};
